/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ w: NonNullable<unknown> }} Water_Efg_ConsumptionInputs */



/**
* | output |
* | --- |
* | "General cold water: {w} m³" |
*
* @param {Water_Efg_ConsumptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const water_efg_consumption = /** @type {((inputs: Water_Efg_ConsumptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Water_Efg_ConsumptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`General cold water: ${i?.w} m³`)
	return /** @type {LocalizedString} */ (`Eau froide générale : ${i?.w} m³`)
});